 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		57: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		57: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"5c41649e0b57c13063bfbd53595d3e4431680e10","3":"59f828f5514afc61aaba0537ccabbd9c4bc22587","4":"framework","5":"05d954cf","6":"f6deff5091ba1b36b10d41e6d8f0f6cc0fc37991","7":"custom-sections-BuyProlon-AccordionItem","8":"custom-sections-BuyProlon-AnnouncementBar","9":"custom-sections-BuyProlon-BuyProlon","10":"custom-sections-BuyProlon-FlavourAccord","11":"custom-sections-BuyProlon-FlavourCard","12":"custom-sections-BuyProlon-ImageOnText","13":"custom-sections-BuyProlon-QAccordion","14":"custom-sections-BuyProlon-TextCard","15":"custom-sections-BuyProlon-TextCardList","16":"custom-sections-BuyProlon-TextOnly","17":"custom-sections-CardsSection-CardsWithImages","18":"custom-sections-CardsSection-CardsWithText","19":"custom-sections-ContactUs-ContactUs","20":"custom-sections-FAQ-FAQ","21":"custom-sections-FeatureSection-Features","22":"custom-sections-Footer-Footer","23":"custom-sections-Footer-FooterWithInput","24":"custom-sections-GetStarted-GetStarted","25":"custom-sections-Header-main-header","26":"custom-sections-Hero-main-hero","27":"custom-sections-HomePage-BenifitSection-BenifitCard-BenifitCard","28":"custom-sections-HomePage-BenifitSection-BenifitSection","29":"custom-sections-HomePage-BuySection-BuySection","30":"custom-sections-HomePage-CartSection-HelthyCommitment","31":"custom-sections-HomePage-CartSection-TestimonialCart","32":"custom-sections-HomePage-CartSection-TestimonialDetail","33":"custom-sections-HomePage-CartSection-TrendingNow","34":"custom-sections-HomePage-CartSection-TrendingProduct","35":"custom-sections-HomePage-DietSection-DietCard-DietCard","36":"custom-sections-HomePage-DietSection-DietSection","37":"custom-sections-HomePage-DietSection-FastingMimicking","38":"custom-sections-HomePage-PromoGrid-Hero","39":"custom-sections-HomePage-PromoGrid-Hero-Left","40":"custom-sections-HomePage-PromoGrid-PromoGrid","41":"custom-sections-HomePage-PromoGrid-ScrollImage","42":"custom-sections-HomePage-Testimonials-Testimonials","43":"custom-sections-HomePage-TextSection-TextSection","44":"custom-sections-HomePage-WorkSection-WorkSection","45":"custom-sections-ImageSection-ImageWithText","46":"custom-sections-ImageSection-TextWithImage","47":"custom-sections-ImageSection-TwoColumnMultipleImages","48":"custom-sections-TextSections-TextBanner","49":"custom-sections-TextSections-TextTwoColumn","50":"custom-sections-custom-sections-product-CardSection-BuyCard","51":"custom-sections-custom-sections-product-CardSection-BuyCardsList","52":"custom-sections-custom-sections-product-ImageSection-OnlyImage","53":"custom-sections-custom-sections-product-PlanSection-PlanCard","54":"custom-sections-custom-sections-product-PlanSection-PlanSection","55":"custom-sections-custom-sections-product-TextSection-HeroBanner","56":"custom-sections-custom-sections-product-TextSection-TextBanner","59":"DescriptionBox","61":"component---src-pages-404-js","62":"component---src-pages-test-js","63":"component---src-theme-templates-main-index-jsx","64":"component---src-theme-templates-page-index-jsx","65":"component---src-theme-templates-product-index-jsx","68":"src-gatsbystorefront-gatsby-theme-storefront-shopify-custom-sections-Footer-FooterSimple","69":"src-slide-cart"}[chunkId]||chunkId) + "-" + {"0":"880dd36382a80fdaa26a","1":"136dffcde22e5b1103b3","2":"50243e8d8cfa5b2e46b0","3":"fe9fde4980f80e358fb0","4":"73bbc34aff8c2c1b0fc3","5":"11870c886c8f106cd99e","6":"b7fdcf982fa91202e379","7":"d87029a00abaafeccde2","8":"cb6cdc2e8a57240c878f","9":"1d1b42c3d2fcae3192da","10":"6b7122c52c1392a536a6","11":"6df99345b934f13a9935","12":"c111f8fbdd7e785e56ab","13":"e6269ad065cef3236fae","14":"675bdcb402925395c939","15":"819048ee2d29d004104f","16":"b6525634eb22ac7d16c8","17":"3a9f46464586fb91656c","18":"39dc2c957c60610468d8","19":"0acdd2b2e4ecf37a5a19","20":"b8180d19d5ca9efefbd5","21":"04567f7ffd6aaeb791ae","22":"5018daf273d7dc12e4b4","23":"e05e9575b3fff5c79d0e","24":"d18de2af6952e7a3860a","25":"a1f6b1c29b69ff39bfa1","26":"aa0d93a2279ee0dae4b7","27":"b0eec92c2f58b096ad86","28":"2eb02a834425378c8bf9","29":"3e41ad689db43004b447","30":"004a5384f880bff95c72","31":"fbf0b53017431464a884","32":"99b7d531ac39d814b387","33":"608c8fba8d19e37d6cc0","34":"80a7197795be18ca17cd","35":"ab53cda18e3e5391de28","36":"49fa1eb1a4fe68cab52c","37":"7fb3e20ac211cac798c4","38":"3413fb021690307594b7","39":"7f3169c468909202cf9e","40":"f913bac986c5b8bb9054","41":"1f3317501f24534debac","42":"765d2bbf149942f43c92","43":"5c62e29f4b2bcb63e849","44":"be16a0a0b67d0bae009e","45":"51c11d14cfc3b9315871","46":"55a6e1722a8d3defc55e","47":"994c3b9ef900e012b98e","48":"2b740c9a5f8340944678","49":"9c1370e4fe143be43719","50":"18e4d34a4e9f9d1949c9","51":"62dc3afdb14f627ba113","52":"f5e3a072e7987440945a","53":"eed246bc7fe3b68e9568","54":"22b3b8468852e38c91c3","55":"457e787a46b7ee33a500","56":"db90fec99ea20d57cbbd","59":"6e3b231824919420543d","61":"1920d9f609667f025f10","62":"9bf0c01e52ac67bd844e","63":"3f332d10ea3c4aa8a0ee","64":"4d6752a9bb589f9b78e5","65":"5a68872568807ef2e814","68":"dfb599b1221a6cbafa72","69":"1d4440d133af0031e377"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"5c41649e0b57c13063bfbd53595d3e4431680e10","3":"59f828f5514afc61aaba0537ccabbd9c4bc22587","4":"framework","5":"05d954cf","6":"f6deff5091ba1b36b10d41e6d8f0f6cc0fc37991","7":"custom-sections-BuyProlon-AccordionItem","8":"custom-sections-BuyProlon-AnnouncementBar","9":"custom-sections-BuyProlon-BuyProlon","10":"custom-sections-BuyProlon-FlavourAccord","11":"custom-sections-BuyProlon-FlavourCard","12":"custom-sections-BuyProlon-ImageOnText","13":"custom-sections-BuyProlon-QAccordion","14":"custom-sections-BuyProlon-TextCard","15":"custom-sections-BuyProlon-TextCardList","16":"custom-sections-BuyProlon-TextOnly","17":"custom-sections-CardsSection-CardsWithImages","18":"custom-sections-CardsSection-CardsWithText","19":"custom-sections-ContactUs-ContactUs","20":"custom-sections-FAQ-FAQ","21":"custom-sections-FeatureSection-Features","22":"custom-sections-Footer-Footer","23":"custom-sections-Footer-FooterWithInput","24":"custom-sections-GetStarted-GetStarted","25":"custom-sections-Header-main-header","26":"custom-sections-Hero-main-hero","27":"custom-sections-HomePage-BenifitSection-BenifitCard-BenifitCard","28":"custom-sections-HomePage-BenifitSection-BenifitSection","29":"custom-sections-HomePage-BuySection-BuySection","30":"custom-sections-HomePage-CartSection-HelthyCommitment","31":"custom-sections-HomePage-CartSection-TestimonialCart","32":"custom-sections-HomePage-CartSection-TestimonialDetail","33":"custom-sections-HomePage-CartSection-TrendingNow","34":"custom-sections-HomePage-CartSection-TrendingProduct","35":"custom-sections-HomePage-DietSection-DietCard-DietCard","36":"custom-sections-HomePage-DietSection-DietSection","37":"custom-sections-HomePage-DietSection-FastingMimicking","38":"custom-sections-HomePage-PromoGrid-Hero","39":"custom-sections-HomePage-PromoGrid-Hero-Left","40":"custom-sections-HomePage-PromoGrid-PromoGrid","41":"custom-sections-HomePage-PromoGrid-ScrollImage","42":"custom-sections-HomePage-Testimonials-Testimonials","43":"custom-sections-HomePage-TextSection-TextSection","44":"custom-sections-HomePage-WorkSection-WorkSection","45":"custom-sections-ImageSection-ImageWithText","46":"custom-sections-ImageSection-TextWithImage","47":"custom-sections-ImageSection-TwoColumnMultipleImages","48":"custom-sections-TextSections-TextBanner","49":"custom-sections-TextSections-TextTwoColumn","50":"custom-sections-custom-sections-product-CardSection-BuyCard","51":"custom-sections-custom-sections-product-CardSection-BuyCardsList","52":"custom-sections-custom-sections-product-ImageSection-OnlyImage","53":"custom-sections-custom-sections-product-PlanSection-PlanCard","54":"custom-sections-custom-sections-product-PlanSection-PlanSection","55":"custom-sections-custom-sections-product-TextSection-HeroBanner","56":"custom-sections-custom-sections-product-TextSection-TextBanner","59":"DescriptionBox","61":"component---src-pages-404-js","62":"component---src-pages-test-js","63":"component---src-theme-templates-main-index-jsx","64":"component---src-theme-templates-page-index-jsx","65":"component---src-theme-templates-product-index-jsx","68":"src-gatsbystorefront-gatsby-theme-storefront-shopify-custom-sections-Footer-FooterSimple","69":"src-slide-cart"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"0a4a99e983e8b7ef2dd7","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
